import { useGenericContext } from "../../hooks";
import { ReferralDashboardContext } from "./ReferralDashboardContext";

export const useReferralDashboard = () => useGenericContext(ReferralDashboardContext);
